// @flow
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

// components
import PageTitle from '../../../components/PageTitle';
import EmailSetup from './EmailSetup';

const Email = (): React$Element<React$FragmentType> => {
    return (
        <>
            <PageTitle
                breadCrumbItems={[
                    { label: 'Templates', path: '/pages/templates/' },
                    // { label: 'Starter', path: '/pages/starter', active: true },
                ]}
                title={'Email Templates'}
            />
            <section className="py-5 bg-light-lighten border-top border-bottom border-light">
                <Container>
                    <Row>
                        <Col>
                            <EmailSetup />
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default Email;
